import { Box, Stack, Skeleton } from "@mui/material";

const DateSlotSkeleton = () => {
  const weekDatesCount = 6;

  return (
    <Box sx={{ p: 4, bgcolor: "#F6F9FC", borderRadius: 3 }}>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 6, alignItems: "center" }}>
        <Skeleton variant="text" width={120} height={32} />

        <Stack direction="row" spacing={2}>
          <Skeleton variant="circular" width={37} height={37} />
          <Skeleton variant="circular" width={37} height={37} />
        </Stack>
      </Box>

      {/* Week Dates */}
      <Box sx={{ display: "flex", gap: "12px", justifyContent: "center", alignItems: "center" }} mb={6}>
        {Array.from({ length: weekDatesCount }).map((_, index) => (
          <Skeleton key={index} variant="rectangular" width={71} height={81} sx={{ borderRadius: "8px" }} />
        ))}
      </Box>

      {/* Time Slots */}
      {Array.from({ length: 2 }).map((_, index) => (
        <Box key={index} sx={{ mb: 3, display: "flex" }}>
          <Skeleton variant="rectangular" width="100%" height={45} sx={{ borderRadius: "8px" }} />
        </Box>
      ))}

      {/* ConsentBox Skeleton */}
      <Box sx={{ mt: 4 }}>
        <Skeleton variant="rectangular" height={60} />
      </Box>

      {/* Action Buttons */}
      <Box sx={{ mt: 6 }}>
        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="right" alignItems="center" spacing={1.5}>
          <Skeleton variant="rectangular" width={120} height={45} />
          <Skeleton variant="rectangular" width={180} height={45} />
        </Stack>
      </Box>
    </Box>
  );
};

export default DateSlotSkeleton;
